import React, { useEffect, useRef, useState } from "react";
import Loader from "../../core/common/selfLoder";
import { all_routes } from "../router/all_routes";
import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import useApi from "../../core/customhook/useApi";
import axios from "axios";
import { apibaseurl, jwttoken } from "../../environment";
import Swal from "sweetalert2";
import Confetti from "react-confetti";
import ConfettiBlast from "./ConfettiBlast ";
// import JSConfetti from "js-confetti";

interface FrequencyData {
  frequency_id: string;
  frequency_name: string;
}

interface FrequencyListMainResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: FrequencyData[];
}

interface AawardData {
  ID: Number;
  award_name: String;
  icon: string;
}
interface AawardListMainResponse {
  success: Boolean;
  message: String;
  statusCode: Number;
  data: AawardData[];
}
interface EmployeeData {
  employee_id: string;
  employee_name: string;
}

interface EmployeeMainResponse {
  success: Boolean;
  message: String;
  data: EmployeeData[];
}
interface AwardNumberData {
  total_earned_points: number;
}
interface awardNumberMainResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: AwardNumberData;
}
const Recognition = () => {
  const [activeTab, setActiveTab] = useState<string>("");
  const [modalData, setModalData] = useState<any>({});
  const [searchValue, setSearchValue] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [textdata, setTextdata] = useState("");
  const [awardidData, setAwardidData] = useState<any>({});
  const [showCelebration, setShowCelebration] = useState(true);
  const jsConfettiRef = useRef(null);




  const recognitionMessages = [
    "🌟 Build a culture of continuous recognition",
    "🏆 Recognize in a meaningful and measurable manner",
    "📈 Boost engagement and productivity levels",
    "💡 Reinforcing values-led behaviour",
    "🎯 Celebrate team milestones and individual achievements",
    "🙌 Foster peer-to-peer appreciation",
    "📣 Highlight efforts publicly and consistently",
    "🤝 Promote inclusive recognition practices",
    "🏅 Reward innovative thinking and problem-solving",
    "💬 Encourage feedback and acknowledgment loops",
  ];
  const {
    data: frequencyListResponse,
    loading: frequencyListLoading,
    error: frequencyListError,
  } = useApi<FrequencyListMainResponse>("/api/frequency-list", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    const firstId = frequencyListResponse?.data?.[0]?.frequency_id;
    if (firstId) {
      setActiveTab(firstId);
    }
  }, [frequencyListResponse]);

  const {
    data: awardListResponse,
    loading: awardListLoading,
    error: awardListError,
  } = useApi<AawardListMainResponse>("/api/award-list", {
    method: "POST",
    autoCall: activeTab === "" ? false : true,
    payload: {
      frequency_id: activeTab,
    },
    dependencies: [activeTab],
  });

  // API CALL FOR employee-directory
  const {
    data: employeeData,
    loading: employeeLoading,
    error: employeeError,
  } = useApi<EmployeeMainResponse>("/api/search-employee-directory", {
    method: "POST",
    autoCall: searchValue.length === 0 ? false : true,
    payload: {
      search: searchValue,
    },
    dependencies: [searchValue],
  });

  // Filter and limit suggestions
  const filtered = employeeData?.data.filter((emp) =>
    emp.employee_name.toLowerCase().includes(searchValue.toLowerCase())
  );
  useEffect(() => {
    const modal = document.getElementById("exampleModalToggle");
    const handleModalHidden = () => {
      setSearchValue("");
      setTextdata("");
      setShowSuggestions(false);
    };
    modal?.addEventListener("hidden.bs.modal", handleModalHidden);
    return () => {
      modal?.removeEventListener("hidden.bs.modal", handleModalHidden);
    };
  }, []);

  const { callApi: addRecognitionApi, loading: addRecognitionLoading } = useApi(
    "/api/add-recognise",
    { method: "POST", autoCall: false }
  );

  const {
    callApi: fetchAwardDescriptionApi,
    loading: fetchAwardDescriptionLoading,
  } = useApi("/api/award-description", { method: "POST", autoCall: false });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const payload = {
      employee_id: searchValue.split(",")[1]?.trim(),
      award_id: modalData.ID,
      citation: textdata,
    };

    try {
      const response = await addRecognitionApi(payload);

      if (response) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Recognition has been submitted successfully.",
        });
        setSearchValue("");
        setTextdata("");
        setShowSuggestions(false);
        document.getElementById("recognitionClose")?.click()
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "There was a problem submitting the recognition.",
      });
    }
  };

  const callDataAward = async (awardId: Number) => {
    try {
      const response = await fetchAwardDescriptionApi({ award_id: awardId });
      if (response) {
        setAwardidData(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const {
    data: awardNumberResponse,
    loading: awardNumberLoading,
    error: awardNumberError,
  } = useApi<awardNumberMainResponse>("/api/award-points", {
    method: "GET",
    autoCall: true,
  });

  function decodeHtml(html: string) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }



  useEffect(() => {
    const celebrationTimer = setTimeout(() => {
      setShowCelebration(false);
      // setShowBlastLeft(true);
      // setShowBlastRight(true);
    }, 10000); // after 1 minute
    return () => clearTimeout(celebrationTimer);
  }, []);

  return (
    <>
      <Loader loading={frequencyListLoading || awardListLoading} />
      <div className="page-wrapper component-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Appreciation Wall</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Communication & Culture</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Appreciation Wall
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                pagination={{
                  clickable: true,
                }}
                navigation={false}
                modules={[Autoplay]}
                className="swiper swiper-basic"
              >
                {recognitionMessages.map((message, index) => (
                  <SwiperSlide key={index} className="swiper-slide">
                    <div className="text-center p-2">
                      <h3 className="mb-0">{message}</h3>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="text-center">
                <h1 className="mb-0">Rewards Point </h1>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="card mb-3">
              <div className="card-header">
                <h5 className="card-title mb-0">My Badges & Values</h5>
              </div>
              <div className="card-body" id="recognition_section">
                <div className="d-flex  flex-wrap align-items-center justify-content-around ">
                  {frequencyListResponse?.data.map((value, index) => (
                    <button
                      key={index}
                      className={`btn px-3  px-md-5 me-2  mb-2  ${activeTab === value.frequency_id
                        ? "text-white"
                        : "text-dark"
                        }`}
                      style={{
                        backgroundColor:
                          activeTab === value.frequency_id
                            ? "#2e3294"
                            : "#EAEAEA",
                      }}
                      onClick={() => setActiveTab(value.frequency_id)}
                    >
                      {value.frequency_name}
                    </button>
                  ))}
                </div>

                <div
                  className="card-body position-relative"
                  style={{ padding: "10px 30px" }}
                >
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    navigation={{
                      nextEl: ".custom-swiper-button-next",
                      prevEl: ".custom-swiper-button-prev",
                    }}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                      },
                      576: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                      },
                      768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                      },
                      992: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                      },
                    }}
                    modules={[Navigation]}
                    className="swiper-navigation"
                  >
                    {awardListResponse?.data.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="card h-100">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                              padding: "1rem",
                              cursor: "pointer",
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModalToggle1"
                            onClick={() => {
                              callDataAward(item.ID);
                            }}
                          >
                            <img
                              src={item.icon}
                              alt="Award"
                              style={{
                                maxWidth: "100px",
                                marginBottom: "1rem",
                              }}
                            />
                            <p>{item.award_name}</p>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div
                    className="custom-swiper-button-prev btn swiper-button-prev position-absolute top-50 start-0 translate-middle-y z-3"
                  // style={{ backgroundColor: "#F69420" }}
                  />
                  <div
                    className="custom-swiper-button-next btn swiper-button-next position-absolute top-50 end-0 translate-middle-y z-3"
                  // style={{ backgroundColor: "#F69420" }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="card mb-3">
              <div className="card-header">
                <h5 className="card-title mb-0">My Earned Points</h5>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <h4>{awardNumberResponse?.data.total_earned_points}</h4>
                  <p>Available Points</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="card mb-3">
              <div className="card-header">
                <h5 className="card-title mb-0">Nominate your Colleague</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  {awardListResponse?.data.map((item, index) => (
                    <div className="col-xl-3 col-lg-4 col-sm-6 col-12 mb-4">
                      <div className="card h-100">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            padding: "1rem",
                          }}
                        >
                          <img
                            src={item.icon}
                            alt="Award"
                            style={{
                              maxWidth: "100px",
                              marginBottom: "1rem",
                            }}
                          />
                          <p>{item.award_name}</p>
                          <button
                            className="btn btn-primary custom_button p-1 px-2"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModalToggle"
                            onClick={() => {
                              setModalData(item);
                            }}
                          >
                            Recognise
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalToggle"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalToggleLabel">
                Recognition Form
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="recognitionClose"
              />
            </div>

            <form onSubmit={postData}>
              <div className="modal-body">
                <div className="mb-3 position-relative">
                  <label className="form-label">
                    Select by Employee Name/Employee ID
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g., Arbind Das, T1-9122"
                    value={searchValue}
                    onFocus={() => setShowSuggestions(true)}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onClick={() => setShowSuggestions(true)}
                    required
                  />

                  {showSuggestions && (
                    <ul
                      className="list-group mt-1 position-absolute w-100"
                      style={{
                        maxHeight: "250px",
                        overflowY: "auto",
                        zIndex: 1050,
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                      }}
                    >
                      {filtered &&
                        filtered.map((emp, index) => (
                          <li
                            key={index}
                            className="list-group-item list-group-item-action"
                            onClick={() => {
                              setSearchValue(
                                `${emp.employee_name}, ${emp.employee_id}`
                              );
                              setShowSuggestions(false);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {emp.employee_name}, {emp.employee_id}
                          </li>
                        ))}
                    </ul>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Reward Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    readOnly
                    value={modalData?.award_name}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Add Citation<span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    placeholder="Enter a short message of appreciation"
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                      setTextdata(e.target.value);
                    }}
                    value={textdata}
                    required
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-cancel"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary custom_button">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalToggle1"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalToggleLabel">
                {awardidData.award_name}
              </h4>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body px-4">
              <img src={awardidData.icon} alt="" style={{ height: "100px" }} />
              <h2 className="text-primary mt-1">Category</h2>
              <p>{awardidData.category_name}</p>
              <h2 className="text-primary">Criteria</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: decodeHtml(awardidData.description),
                }}
              />
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* {showCelebration && (
        <>
          <Confetti width={window.innerWidth} height={window.innerHeight} />
        </>
      )} */}
      <ConfettiBlast />

      {/* {showCelebration && (
        <div className="celebration-video-overlay">
          <img
            src="../assets/img/animation/celebration.gif"
            alt="Celebration"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      )} */}


      {/* {showCelebration && (
        <div className="celebration-video-overlay">
          <video
            src="../assets/img/animation/wall.mp4"
            autoPlay
            muted
            playsInline
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <div className="celebration-message">🎉 Celebrations Begin! 🎉</div>
        </div>
      )} */}

    </>
  );
};

export default Recognition;
